module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-body__inner"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('h3', [_vm._v("インプット")]), _vm._v(" "), _c('div', {
    staticClass: "e-grid -double"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "e-label-list"
  }, _vm._l((_vm.testCount), function(i) {
    return _c('label', {
      staticClass: "e-label"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      }
    }), _c('span', {
      staticClass: "label"
    }, [_vm._v("check")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "e-label-list"
  }, _vm._l((_vm.testCount), function(i) {
    return _c('label', {
      staticClass: "e-label"
    }, [_c('input', {
      attrs: {
        "type": "radio"
      }
    }), _c('span', {
      staticClass: "label"
    }, [_vm._v("check")])])
  }))]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('h3', [_vm._v("アイコン")]), _vm._v(" "), _c('div', {
    staticClass: "icon-list"
  }, _vm._l((_vm.icons), function(icon) {
    return _c('span', [_c('c-icon', {
      attrs: {
        "name": icon,
        "feature": '-small'
      }
    })], 1)
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body__title"
  }, [_c('h2', [_vm._v("テンプレート")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e-section"
  }, [_c('h3', [_vm._v("パラグラフ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit nesciunt nihil, sunt illo soluta voluptates consectetur, dolorem minima exercitationem quas provident ipsum aliquam dolor deserunt sed laudantium ipsa cupiditate vel.\n\t\t\t")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit nesciunt nihil, sunt illo soluta voluptates consectetur, dolorem minima exercitationem quas provident ipsum aliquam dolor deserunt sed laudantium ipsa cupiditate vel.\n\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "e-grid -triple"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h3', [_vm._v("リスト")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Foo")]), _vm._v(" "), _c('li', [_vm._v("Bar")]), _vm._v(" "), _c('li', [_vm._v("Baz")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h3', [_vm._v("数字リスト")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Foo")]), _vm._v(" "), _c('li', [_vm._v("Bar")]), _vm._v(" "), _c('li', [_vm._v("Baz")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h3', [_vm._v("定義リスト")]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("title")]), _vm._v(" "), _c('dd', [_vm._v("content content content")]), _vm._v(" "), _c('dt', [_vm._v("title")]), _vm._v(" "), _c('dd', [_vm._v("content content content")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e-section"
  }, [_c('h3', [_vm._v("ボタン")]), _vm._v(" "), _c('button', {
    staticClass: "e-button"
  }, [_vm._v("Button")]), _vm._v(" "), _c('button', {
    staticClass: "e-button -primary"
  }, [_vm._v("Primary Button")]), _vm._v(" "), _c('button', {
    staticClass: "e-button -link"
  }, [_vm._v("Link Button")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    staticClass: "e-input-text",
    attrs: {
      "type": "text",
      "placeholder": "testinput"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    staticClass: "e-input-text -full",
    attrs: {
      "type": "text",
      "placeholder": "testinput"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('textarea', {
    staticClass: "e-input-text -full",
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "textarea"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "e-grid -double"
  }, [_c('div', {
    staticClass: "col"
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5999d310","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/page/template.vue
// module id = 62
// module chunks = 0